import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";

export const DraftBanner = () => (
  <div className="bg-[#F3E9D4] px-5 py-3 text-center text-sm text-[#6B531F]" data-testid="draft-legal-banner">
    <strong className="font-semibold">Draft for business review.</strong> This language
    is a working draft, not final legal language. Have counsel review before launch.
  </div>
);

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Policy (Draft) — Riverstone Partners"
        description="Draft privacy policy for Riverstone Partners, prepared for business review prior to launch."
        path="/privacy"
      />
      <DraftBanner />
      <section className="py-16 md:py-24">
        <div className="shell max-w-3xl space-y-10">
          <div>
            <p className="eyebrow text-forest">Legal</p>
            <h1 className="mt-4 font-serif text-4xl font-light tracking-tight text-navy" data-testid="privacy-title">
              Privacy Policy
            </h1>
            <p className="mt-2 text-sm text-charcoal/60">Draft — [Effective date to be set at launch]</p>
          </div>

          {[
            ["Information we collect", (
              <>
                When you submit an inquiry or partner-interest form, we collect the
                information you provide: your name, email address, company, optional
                phone number, the service you’re interested in, and your message. We
                also record the page you submitted from, for context.
              </>
            )],
            ["How we use it", (
              <>
                We use your information solely to respond to your inquiry, arrange a
                conversation, and, where relevant, introduce you to the appropriate
                solution provider. We do not sell your information, and we do not add
                you to marketing lists without your consent.
              </>
            )],
            ["Sharing with providers", (
              <>
                If your inquiry leads to an introduction, the relevant specialist
                provider may receive your contact details and the information you chose
                to share so they can respond. We aim to be clear when an introduction
                is happening.
              </>
            )],
            ["Sensitive information", (
              <>
                Our forms are not intended for patient records, sensitive medical
                details, or financial account information. Please do not submit those
                through this website.
              </>
            )],
            ["Retention & security", (
              <>
                Inquiries are stored securely and retained only as long as needed to
                respond and maintain a record of the relationship. Retention periods
                will be finalized before launch.
              </>
            )],
            ["Your choices", (
              <>
                You may ask us to correct or delete the information you submitted by
                contacting us at the phone number listed on our Contact page.
              </>
            )],
            ["Changes", (
              <>
                This policy is a draft for business review and may change materially
                before launch. The final version will carry an effective date.
              </>
            )],
          ].map(([h, body], i) => (
            <Reveal key={h} delay={i * 0.03}>
              <h2 className="font-serif text-2xl text-navy">{h}</h2>
              <p className="mt-3 leading-relaxed text-charcoal/80">{body}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
